import { render } from "./App.vue?vue&type=template&id=0393fd7b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0393fd7b&lang=css"

import exportComponent from "../node_modules/_vue-loader@17.3.1@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__